module.exports = __webpack_public_path__ + "static/media/viewReportsSelected.6205ece5.svg";